import AddVendorMenuContainer from "./AddVendorMenuContainer";
export default AddVendorMenuContainer;
